import { useEffect } from 'react';

function TestV2() {
    useEffect(() => {
        localStorage.setItem('v2_test', JSON.stringify({
            step: 'TestV2 컴포넌트 마운트됨',
            timestamp: new Date().toISOString(),
            pathname: window.location.pathname
        }));
    }, []);

    return (
        <div style={{ padding: '20px', fontSize: '20px' }}>
            <h1>V2 테스트 페이지</h1>
            <p>이 페이지가 보이면 V2 라우트가 작동하는 것입니다.</p>
            <p>경로: {window.location.pathname}</p>
            <p>타임스탬프: {new Date().toISOString()}</p>
        </div>
    );
}

export default TestV2;
